import React, {useContext, useEffect, useState} from "react";
import { Control, FieldErrors } from "react-hook-form";

import { getInsurances } from "../../../../util/Api/api";
import { AppContext } from "../../../../util/context";
import SelectDropdown from ".";
import { Insurance, IFieldDropdown } from "./SelectDropdown.types";

const InsuranceDropdown = (props: { fieldData: IFieldDropdown, errors: FieldErrors, control: Control }) => {
  const {
    fieldData,
    errors,
    control,
  } = props;
  const [data, setData] = useState(fieldData);
  const { settings: { locale } } = useContext(AppContext);

  useEffect(() => {returnAllInsuranceData()},[])

  const returnAllInsuranceData = async () => {
    const insuranceData = await getInsurances(locale);
    getInsuranceOptions(insuranceData);
  }

  const getInsuranceOptions = (insuranceData: Array<Insurance>) => {
    const options = insuranceData?.map((insurance) => (
      {
        label: insurance.name,
        value: insurance.name,
        type: insurance.type
      }));

      setData(Object.assign({}, fieldData, {options}));
  };

  return data.options ? <SelectDropdown fieldData={data} errors={errors} control={control} /> : null;
}

export default InsuranceDropdown;
